const SignUp = () => {
	return (
		<div id='signUp' className='container paddingHeader'>
			<h2>Comming soon...</h2>
		</div>
	);
};

export default SignUp;
